"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var redux_logger_1 = require("redux-logger");
var persistConfig_1 = __importDefault(require("./persistConfig"));
var constants_1 = require("redux-persist/es/constants");
var logger = (0, redux_logger_1.createLogger)({
    level: "info",
    collapsed: true,
    duration: true,
    timestamp: true,
    logErrors: true,
    diff: false,
    predicate: function (getState, action) { return true; },
});
var store = (0, toolkit_1.configureStore)({
    reducer: persistConfig_1.default,
    middleware: function (getDefaultMiddleware) {
        var middleware = getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [constants_1.FLUSH, constants_1.REHYDRATE, constants_1.PAUSE, constants_1.PERSIST, constants_1.PURGE, constants_1.REGISTER], // Исключаем действия redux-persist
            },
        });
        // if (process.env.NODE_ENV === "development") {
        //   return middleware.concat(logger); // Добавляем logger только в dev-режиме
        // }
        return middleware;
    },
});
exports.default = store;
